const SEARCH_STEP_INDEX = 0;
const CART_STEP_INDEX = 1;
const PAYMENT_STEP_INDEX = 2;
const CONFIRM_EXCHANGE_STEP_INDEX = 3;

export { SEARCH_STEP_INDEX, CART_STEP_INDEX, PAYMENT_STEP_INDEX, CONFIRM_EXCHANGE_STEP_INDEX };
